module.exports = __webpack_public_path__ + "static/media/play-icon.4320d390.png";